module.exports = __webpack_public_path__ + "static/media/king_spade.1e757b70.png";